// Helper functions for formatting autoprovisioning configuration display values

// District admins inclusion type labels
export const DISTRICT_ADMINS_LABELS = {
  none: 'Do not include district admins (default)',
  all: 'Include all district admins',
  specific: 'Include specific admins'
}

// Helper function to get district admins inclusion type from clever options
export function getDistrictAdminsInclusionType(cleverOptions) {
  if (!cleverOptions) return null
  
  if (cleverOptions.include_district_admins) {
    return 'all'
  }
  
  if (cleverOptions.district_admin_emails_to_include?.length > 0) {
    return 'specific'
  }
  
  return 'none'
}

// Helper function to get OneRoster API version display
export function getOneRosterApiVersionDisplay(apiPathPrefix) {
  switch (apiPathPrefix) {
    case 'ims/oneroster/rostering/v1p2':
      return 'v1.2'
    case 'ims/oneroster/v1p1':
      return 'v1.1'
    default:
      return apiPathPrefix
  }
}

// Helper to get Clever configuration display data
export function getCleverConfigDisplay(lambdaInput) {
  const token = lambdaInput?.clever_config?.bearer_token || ''
  const cleverOptions = lambdaInput?.clever_options
  
  const inclusionType = getDistrictAdminsInclusionType(cleverOptions)
  const districtAdmins = DISTRICT_ADMINS_LABELS[inclusionType] || ''
  
  return {
    bearerToken: token,
    districtAdmins,
    districtAdminEmails: cleverOptions?.district_admin_emails_to_include || []
  }
}

// Helper to get OneRoster configuration display data
export function getOneRosterConfigDisplay(lambdaInput) {
  const config = lambdaInput?.provider_config || {}
  const options = lambdaInput?.oneroster_options || {}
  
  return {
    clientId: config.client_id,
    clientSecret: config.client_secret,
    endpoint: config.endpoint,
    apiVersion: getOneRosterApiVersionDisplay(config.api_path_prefix),
    uniqueIdField: options.unique_id_field,
    titleField: options.metadata_title_field
  }
}

// Helper to get S3 CSV configuration display data
export function getS3CsvConfigDisplay(lambdaInput) {
  const s3Config = lambdaInput?.s3_csv_config || {}
  const fieldMappings = lambdaInput?.s3_csv_options?.field_mappings || {}
  
  return {
    inputDirectory: s3Config.s3_prefix,
    filenamePrefix: s3Config.filename_prefix,
    fieldMappings
  }
}
